module.exports = __webpack_public_path__ + "static/media/1.90c20624.svg";